module.exports = __webpack_public_path__ + "static/media/contact-banner.91589ee1.jpg";